import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import "../assets/styles/swiper.css";
import { Mousewheel, Pagination } from "swiper/modules";

import home1 from "../assets/img/home1.png"
import home2 from "../assets/img/home2.png"
import home3 from "../assets/img/home3.png"
import home4 from "../assets/img/home4.png"

import contactIcon from "../assets/img/contactIcon.png"

const Index = styled.div`
  // background-color: red;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HomeContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10rem;
  padding: 0 15rem;
  justify-content: space-between;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  z-index: 2;
  color: black;
  font-size: 4rem;
  font-weight: 600;
  line-height: 5rem;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    line-height: 3rem;
  }
`;

const TextSmall = styled.div`
  margin-top: 1rem;
  text-align: left;
  line-height: 2.2rem;
  font-weight: 500;
  font-size: 1.5rem;
  color: black;
  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const HomeImage = styled.div`
  background-image: url(${home1});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 35rem;
  height: 35rem;
  animation: 1.5s ease-in-out 0s infinite alternate none running bounce;
  @keyframes bounce {
    0% {
     transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(0);
    }
   }
`;
const HomeImage2 = styled.div`
  background-image: url(${home2});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 35rem;
  height: 35rem;
  animation: 1.5s ease-in-out 0s infinite alternate none running bounce;
  @keyframes bounce {
    0% {
     transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(0);
    }
   }
`;
const HomeImage3 = styled.div`
  background-image: url(${home3});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 35rem;
  height: 35rem;
  animation: 1.5s ease-in-out 0s infinite alternate none running bounce;
  @keyframes bounce {
    0% {
     transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(0);
    }
   }
`;
const HomeImage4 = styled.div`
  background-image: url(${home4});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 35rem;
  height: 35rem;
  animation: 1.5s ease-in-out 0s infinite alternate none running bounce;
  @keyframes bounce {
    0% {
     transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(0);
    }
   }
`;

const Contact = styled(Link)`
  position: fixed;
  display: flex;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.3);
  background-image: url(${contactIcon});
  background-size: contain;
  bottom: 0;
  right: 0;
  margin: 3rem;
  z-index: 100;
  align-items: center;
  justify-content: center;
`;


export default () => {
  return (
    <Index>
      <Contact to="/contact"/>
      <Swiper
        direction={"vertical"}
        slidesPerView={1}
        mousewheel={true}
        loop={true}
        pagination={{
          clickable: true,
        }}
        modules={[Mousewheel, Pagination]}
        className="mySwiper"
        speed={800}
      >
        <SwiperSlide>
        
          <HomeContainer>   
            {/* <p>we make future</p>     */}
            <Text >
              만드는 이들의
              <br />
              <p style={{color:"#175fe8"}}>
                사회도전망
              </p>
              <TextSmall >
                우리는 지금 어디에 살고 있나요?
                <br />
                살고 싶은 마을, 살고 싶은 방식을 고민합니다.
              </TextSmall>
            </Text>
            <HomeImage />
          </HomeContainer>   
        </SwiperSlide>

        <SwiperSlide>
          <HomeContainer>       
            <Text >
              코끼리협동조합
              <TextSmall >
                지역 사회 문제를 면밀히 마주하고,
                <br />
                해소하기 위해 노력합니다.
              </TextSmall>
            </Text>
            <HomeImage2 />
          </HomeContainer>   
        </SwiperSlide>

        <SwiperSlide>
          <HomeContainer>       
            <Text >
              사회실험공간 여그
              <TextSmall >
                지역의 이해를 바탕으로 지역 곳곳에 숨어있는
                <br />
                사회 문제를 발견하고 해결합니다.
              </TextSmall>
              </Text>
            <HomeImage3 />
          </HomeContainer>   
        </SwiperSlide>

        <SwiperSlide>
          <HomeContainer>       
            <Text >
              코끼리 메이커스페이스
              <TextSmall >
                메이커 문화를 확산하고 메이커를 양성하는
                <br />
                전문형 메이커스페이스 입니다.
              </TextSmall>
            </Text>
            <HomeImage4 />
          </HomeContainer>   
        </SwiperSlide>
      </Swiper>
            
    </Index>
  );
};
